import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
import {
  Box,
  CardContent,
  Divider,
  Link,
  Typography,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Alert,
} from '@material-ui/core';
import { onLogin, onLogout, hideLogin } from '../../store/actions/auth';
import XIcon from '../../components/icons/X';

const Login: FC<any> = ({
  isLoginError,
  onLogin: onLoginExecutor,
  messageError,
  hideLogin: onHideLogin,
}) => {
  const validation = yup.object({
    username: yup.string().required('El campo usuario es obligatorio'),
    password: yup.string().required('El campo contraseńa es obligatorio'),
    remember: yup.boolean(),
  });

  const onLoginClick = (values) => onLoginExecutor(values);

  return (
    <>
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          p: 4,
        }}
      >
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            mb: 3,
          }}
        >
          <div>
            <Typography color="textPrimary" gutterBottom variant="h4">
              ¡Bienvenido!
            </Typography>
          </div>
          <div>
            <Button onClick={() => onHideLogin()}>
              <XIcon />
            </Button>
          </div>
        </Box>
        <Formik
          initialValues={{ username: '', password: '', remember: false }}
          validationSchema={validation}
          onSubmit={(values) => {
            onLoginClick(values);
          }}
        >
          {({ values, handleChange, handleSubmit, touched, errors }) => (
            <form onSubmit={handleSubmit}>
              <TextField
                id="username"
                name="username"
                type="text"
                value={values.username}
                onChange={handleChange}
                placeholder="Usuario"
                error={touched.username && Boolean(errors.username)}
                helperText={touched.username && errors.username}
                fullWidth
                style={{ marginBottom: 16 }}
              />
              <TextField
                id="password"
                name="password"
                type="password"
                value={values.password}
                onChange={handleChange}
                placeholder="Contraseña"
                error={touched.password && Boolean(errors.password)}
                helperText={touched.password && errors.password}
                fullWidth
              />
              <FormControlLabel
                control={(
                  <Checkbox
                    name="remember"
                    color="primary"
                    value={values.remember}
                    onChange={handleChange}
                  />
                )}
                label="Recordarme"
              />
              {isLoginError && <Alert severity="error">{messageError}</Alert>}
              <Box sx={{ mt: 2 }}>
                <Button
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Ingresar
                </Button>
              </Box>
              <Divider sx={{ my: 3 }} />
              <Link
                color="textPrimary"
                component={RouterLink}
                sx={{ mt: 1 }}
                to="/password-recovery"
                variant="body2"
              >
                ¿Olvidaste tu contrase&ntilde;a?
              </Link>
            </form>
          )}
        </Formik>
      </CardContent>
    </>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isLoginError: state.auth.loginError,
  messageError: state.auth.messageError,
});

export default connect(mapStateToProps, {
  onLogin,
  onLogout,
  hideLogin,
})(Login);
